import { useMutation, useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AssociateReqBody } from '../../../types/associates';
import { AcademiaResponse } from '../../../types/common';
import { UserProfile } from '../../../types/users';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useUserProfileActions = (whichAction: '', userProfileId?: number) => {
  // query function to fetch user profile by profile id declared here
  const getUserProfileByIdHandler = useQuery({
    queryKey: ['user-profile-by-id', userProfileId],
    queryFn: async (): Promise<AcademiaResponse<UserProfile>> => {
      const response = await getPrivateAxiosInstance('user').get(
        `/user/profile/${userProfileId}/`
      );

      return response.data;
    },

    ...returnQueryConfig(!!userProfileId),
  });

  // mutation function uo update user profile declared here
  const updateUserProfileByIdHandler = useMutation({
    mutationFn: async ({
      profileId,
      body,
    }: {
      profileId: number;
      body: AssociateReqBody;
    }) => {
      const response = await getPrivateAxiosInstance('user').patch(
        `/user/profile/${profileId}/partial/update/`,
        body
      );

      return response.data;
    },
  });

  return { getUserProfileByIdHandler, updateUserProfileByIdHandler };
};

export default useUserProfileActions;
